import React from "react";

import { PinIcon, PriceBlock, StarRating, SupplierAvatar } from "./DetailBits";
import { formatDistanceKm } from "../detailMappers";

const SupplierRow = ({ card, selected, onSelect, onInfo }) => {
  const distance = Number.isFinite(card.distanceKm)
    ? `${formatDistanceKm(card.distanceKm)} away`
    : card.addressLine || "Distance unavailable";

  return (
    <li
      role="none"
      className={`sy-supplier-row${selected ? " is-selected" : ""}${
        card.deliverable ? "" : " is-blocked"
      }`}
    >
      <button
        type="button"
        role="radio"
        aria-checked={selected}
        className="sy-supplier-main"
        onClick={() => onSelect(card)}
      >
        <span className="sy-supplier-pick" aria-hidden="true">
          <svg viewBox="0 0 20 20">
            <path d="M5 10.5 8.5 14l6.5-7" />
          </svg>
        </span>

        <SupplierAvatar name={card.name} logoUrl={card.logoUrl} size={44} />

        <span className="sy-supplier-body">
          <span className="sy-supplier-namerow">
            <span className="sy-supplier-name">{card.name}</span>

            {card.highlighted && (
              <span className="sy-badge sy-badge-best">Best price</span>
            )}

            {card.discounted && <span className="sy-badge sy-badge-deal">On promotion</span>}

            {card.inStock === false && (
              <span className="sy-badge sy-badge-stock">Out of stock</span>
            )}
          </span>

          <span className="sy-supplier-meta">
            {card.totalRatings ? (
              <StarRating rating={card.rating} total={card.totalRatings} />
            ) : null}

            <span className="sy-supplier-distance">
              <PinIcon />
              {distance}
            </span>
          </span>

          {card.notice && (
            <span className="sy-supplier-pill">{card.notice.badge}</span>
          )}
        </span>

        <PriceBlock
          price={card.price}
          originalPrice={card.originalPrice}
          currency={card.currency}
          perKg={card.pricePerKg}
          align="right"
        />
      </button>

      <button
        type="button"
        className="sy-supplier-info"
        onClick={() => onInfo(card)}
        aria-label={`About ${card.name}`}
      >
        <span aria-hidden="true">i</span>
      </button>
    </li>
  );
};

export default React.memo(SupplierRow);
